import type { VoiceProfile } from "../types/app";

let primed = false;

export function getJapaneseVoices(): SpeechSynthesisVoice[] {
  if (!("speechSynthesis" in window)) return [];
  return window.speechSynthesis.getVoices().filter((voice) => voice.lang.toLowerCase().startsWith("ja"));
}

export function primeSpeechSynthesis(): boolean {
  if (!("speechSynthesis" in window) || !window.speechSynthesis || typeof SpeechSynthesisUtterance === "undefined") return false;
  try {
    window.speechSynthesis.resume();
    if (primed) return true;
    const utterance = new SpeechSynthesisUtterance("\u200B");
    utterance.lang = "ja-JP";
    utterance.volume = 0;
    utterance.rate = 2;
    window.speechSynthesis.speak(utterance);
    primed = true;
    return true;
  } catch {
    return false;
  }
}

export function speakText(text: string, voiceURI: string | undefined, profile: VoiceProfile | undefined): Promise<boolean> {
  if (!("speechSynthesis" in window) || !window.speechSynthesis || typeof SpeechSynthesisUtterance === "undefined") {
    return Promise.resolve(false);
  }
  return new Promise((resolve) => {
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    const voices = getJapaneseVoices();
    const voice =
      voices.find((item) => item.voiceURI === voiceURI) ??
      voices.find((item) => item.default) ??
      voices[0];
    if (voice) utterance.voice = voice;
    utterance.lang = "ja-JP";
    utterance.pitch = profile?.pitch ?? 1.05;
    utterance.rate = profile?.rate ?? 0.88;
    utterance.volume = profile?.gain ?? 0.9;
    let settled = false;
    let started = false;
    const finish = (played: boolean) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(watchdog);
      resolve(played);
    };
    utterance.onstart = () => {
      started = true;
    };
    utterance.onend = () => finish(true);
    utterance.onerror = () => finish(false);
    const watchdog = window.setTimeout(() => finish(started), Math.min(60_000, Math.max(12_000, text.length * 220)));
    window.setTimeout(() => {
      window.speechSynthesis.resume();
      window.speechSynthesis.speak(utterance);
    }, 40);
  });
}

export function stopSpeech(): void {
  if ("speechSynthesis" in window) window.speechSynthesis.cancel();
}
